/* eslint-disable no-unused-vars */
import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';

export interface UploadCSVFormState {
  file: File | null;
  reason: string;
}

interface UploadCSVFormContextType {
  formState: UploadCSVFormState;
  setFormState: React.Dispatch<React.SetStateAction<UploadCSVFormState>>;
  handleFileChange: (file: File | null) => void;
  handleReasonChange: (reason: string) => void;
}

const UploadCSVFormContext = createContext<UploadCSVFormContextType | undefined>(undefined);

export const useUploadCSVFormContext = () => {
  const ctx = useContext(UploadCSVFormContext);
  if (!ctx) {
    throw new Error('useUploadCSVFormContext must be used within an UploadCSVFormProvider');
  }
  return ctx;
};

export const UploadCSVFormProvider = ({ children }: { children: ReactNode }) => {
  const [formState, setFormState] = useState<UploadCSVFormState>({
    file: null,
    reason: '',
  });

  const handleFileChange = useCallback((file: File | null) => {
    setFormState(prev => ({ ...prev, file }));
  }, []);

  const handleReasonChange = useCallback((reason: string) => {
    setFormState(prev => ({ ...prev, reason }));
  }, []);

  return (
    <UploadCSVFormContext.Provider
      value={{ formState, setFormState, handleFileChange, handleReasonChange }}
    >
      {children}
    </UploadCSVFormContext.Provider>
  );
};
